import type { ILocationRepository, LocationCreateInput } from '../repositories/ILocationRepository.js';
import type { LocationEntity } from '../entities/LocationEntity.js';

interface Deps { locationRepository: ILocationRepository; }

export function createCreateLocationUseCase({ locationRepository }: Deps) {
  return async function createLocation(input: LocationCreateInput): Promise<LocationEntity> {
    return locationRepository.create(input);
  };
}
